/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Settings_ToggleInputs */

const en_simple_settings_toggle = /** @type {(inputs: Simple_Settings_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn on simple mode`)
};

const id_simple_settings_toggle = /** @type {(inputs: Simple_Settings_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyalakan mode sederhana`)
};

/**
* | output |
* | --- |
* | "Turn on simple mode" |
*
* @param {Simple_Settings_ToggleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_settings_toggle = /** @type {((inputs?: Simple_Settings_ToggleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Settings_ToggleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_settings_toggle(inputs)
	return en_simple_settings_toggle(inputs)
});